
import { Component, Vue, Ref } from 'vue-property-decorator'
import { OnlineService } from '@/services'
import { isFunction, remove } from 'lodash'
import { parseTime, downloadFile } from '@/common/utils'
import { generateComment, commentTypes, statusTypes } from '@/settings/online'
import axios from 'axios'
import FullLoading from '@/components/full_loading/index.vue'
import EvaluationPannel from '../components/evaluation_pannel/index.vue'
import OrderInfo from '../components/order_info/index.vue'
import OrderComment from '../components/order_comment/index.vue'
import ChatRecordItem from '@/components/chat_record/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

// 聊天记录列表类型
const listType = {
    chat: 'chat',           // 聊天类型
    grade: 'grade'          // 评分类型
}

@Component({
    name: 'online-normal-detail',
    components: {
        ChatRecordItem,
        FullLoading,
        EvaluationPannel,
        OrderInfo,
        OrderComment,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize!: number
    private pageTotal!: number
    private chatToBottom: any
    private commentLoading!: boolean
    private chatListEl!: HTMLElement
    private fetchTimer!: number
    private loopCancel!: Boolean

    private latestLen = 0
    private latestVisible = false
    private pageIndex = 1
    private isLoading = false
    private orderId = ''
    private order: any = {
        status: {},
        paoding_user: {},
        reason_for_closure: {},
        satisfaction: {}
    }
    private chatRecords: any[] = []

    get noMore() {
        return this.chatRecords.length >= this.pageTotal
    }
    // 是否协助已关闭
    get isClosed() {
        return this.order.status.id === statusTypes.closed.value
    }
    // 待分派状态
    get isUnSigned() {
        return this.order.status.id === statusTypes.unassigned.value
    }
    get isEvaluating() {
        // 判断评论列表最后一条评论是否是评价类型
        const lastItem = this.chatRecords[this.chatRecords.length - 1]
        if (!lastItem) {
            return false
        }
        return lastItem.type === listType.grade
    }
    // 发送方头像，因为庖丁目前暂未有头像
    // 所以默认使用同一个头像
    get userAvatar() {
        return 'https://images.media.beer/85265cc54e42452795b5ffa8dc1d3757.png'
    }
    created() {
        // 轮询数据放弃开关
        this.loopCancel = false
        this.fetchTimer = 0
        this.commentLoading = true
        this.pageTotal = 0
        this.pageSize = 8
        this.matchQuery()
        this.$title('Loading - | 协助详情 - 庖丁')
    }
    async mounted() {
        await this.getOrderDetail()
        if (!this.order.id) {
            return 
        }
        this.$nextTick(() => {
            this.initChatListEl()
        })
        this.getChatRecords((comments: any[]) => {
            this.chatRecords.unshift(...comments)
            this.$nextTick(() => {
                this.scrollToBottom(() => {
                    this.commentLoading = false
                })
            })
            this.startLoopFetch()
        })
    }
    // 下载文件
    async onDownloadFile({ target }: any) {
        const { url, name } = target.dataset
        if (url == null) {
            return
        }
        const result = await axios.get(url, {
            responseType: 'blob'
        })
        if (result.status === 200) {
            return downloadFile(result.data, name)
        }
        this.$merror('发生错误, 请稍后再试')
    }
    // 获取协助聊天记录
    async getChatRecords(option: any, callback?: Function) {
        if (isFunction(option)) {
            callback = option
            option = null
        }
        const params = option || {
            work_order_id: this.order.id,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await OnlineService.getCommentList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            // 转换后的评论
            const comments = result.data.list.reverse().map(generateComment)
            if (callback && isFunction(callback)) {
                callback(comments)
            } else {
                this.chatRecords.unshift(...comments)
            }
        }
    }
    // 获取协助详情
    async getOrderDetail() {
        const params = { id: this.orderId }
        const result = await OnlineService.getOrderDetail(params)
        if (result.status === 200) {
            this.order = result.data
            this.$title(`${result.data.title} | 协助详情 - 庖丁`)
            return
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 发起评价
    async onAppRaise() {
        const params = {
            work_order_id: this.orderId,
            type_id: commentTypes.feedback.value
        }
        const result = await OnlineService.createComment(params)
        if (result.status === 200) {
            // 插入一条评论
            this.pushRaiseComment(result.data)
            return this.$nextTick(() => {
                this.scrollToBottom()
            })
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 创建评论
    async onCreateComment(payload: any) {
        // 开启控制开关
        this.loopCancel = true
        // 停止轮询
        this.stopLoopFetch()
        // 先获取最新评论并进行合并
        await this.pullComment()
        const { message, type, filename, url, success, fail, fileType } = payload
        const params = {
            work_order_id: this.orderId,
            type_id: type,
            content: message,
            file_name: filename,
            file_url: url
        }
        const result = await OnlineService.createComment(params)
        //* result.data --> 最新的评论 id
        // 关闭控制开关
        this.loopCancel = false
        // 开启轮询
        this.startLoopFetch()
        if (result.status === 200) {
            let record: any = {
                type: listType.chat,
                id: result.data,
                isSend: true,
                avatar: this.userAvatar,
                label: parseTime(new Date(), '{y}-{m}-{d} {h}:{i}')
            }
            if (url) {
                record.url = url
                record.fileType = fileType
                record.message = filename
                record.isFile = true
            } else {
                record.message = message
            }
            this.chatRecords.push(record)
            // 如果还是处于未分派状态
            if (this.isUnSigned) {
                // 重新获取数据
                this.getOrderDetail()
            }
            success && success()
            return this.$nextTick(() => {
                this.scrollToBottom()
            })
        }
        fail && fail()
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 拉取最新数据并合并
    async pullComment(callback?: Function) {
        const params = {
            work_order_id: this.orderId,
            page_index: 1,
            page_size: this.pageSize
        }
        const result = await OnlineService.getCommentList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            if (callback) {
                return callback(result.data.list)
            }
            // 转换后的评论
            const comments = result.data.list.reverse().map(generateComment)
            // 合并操作
            this.mergeChatRecordBackward(this.chatRecords, comments)
        }
    }
    // 加载历史记录
    loadMoreChatRecord() {
        if (this.commentLoading || this.noMore) {
            return
        }
        this.commentLoading = true
        // 开启控制开关
        this.loopCancel = true
        // 停止轮询
        this.stopLoopFetch()

        const firstItem = this.chatRecords[0]
        const params = {
            work_order_id: this.orderId,
            id_lt: firstItem.id
        }

        this.getChatRecords(params, (comments: any[]) => {
            const height = this.chatListEl.scrollHeight
            setTimeout(() => {
                // 延迟 1000ms 是因为使用笔记本触摸板快速滑动时，存在惯性滚动
                // mac 尤其明显
                // 更新列表前的滚动高度
                this.chatRecords.unshift(...comments)

                this.$nextTick(() => {
                    this.scrollToBottom(this.chatListEl.scrollHeight - height)
                    this.commentLoading = false
                    // 关闭控制开关
                    this.loopCancel = false
                    // 开启轮询
                    this.startLoopFetch()
                })
            }, 1000)
        })
    }
    matchQuery() {
        this.orderId = this.$route.params.id    
    }
    // 是否正常的聊天记录
    isChat({ type }: any) {
        return type === listType.chat
    }
    // 是否评价模块
    isGrade({ type }: any) {
        return type === listType.grade
    }
    // 是否倒数第一或第二项
    isLastItem(idx: number) {
        if (this.chatRecords.length - 1 === idx) {
            return true
        }
        if (this.chatRecords.length - 2 && this.isClosed) {
            return true
        }
        return false
    }
    // 是否已关闭协助
    isEnd(order: any) {
        return order.type_id === commentTypes.notice.value
    }
    // 插入评价评论
    pushRaiseComment(id: any) {
        this.chatRecords.push({
            id,
            type: listType.grade,
            isSend: false,
            label: new Date(),
            data: ''
        })
    }
    scrollToBottom(height: any = null, callback?: Function) {
        if (isFunction(height)) {
            callback = height
            height = null
        }
        this.chatListEl.scrollTop = height != null ? height : this.chatListEl.scrollHeight
        callback && callback()
    }
    initChatListEl() {
        this.chatListEl = document.querySelector('#help-report-detail .conversation-body') as HTMLElement
    }
    listenChatBodyScroll(event: any) {
        const { scrollTop } = event.target
        if (scrollTop <= 0) {
            this.loadMoreChatRecord()
        }
    }
    // 新消息点击
    showLatestNew() {
        this.scrollToBottom(() => {
            this.latestVisible = false
            this.latestLen = 0
        })
    }
    // 向后合并列表
    mergeChatRecordBackward(oldList: any[], newList: any[]) {
        const getIndex = (item: any, list: any[]) => list.findIndex(n => n.id === item.id)
        // 需要删除的评论元素
        let needDeleteItem: any = null
        // 获取旧数据列表的最后一项
        let lastItem = oldList[oldList.length - 1]
        // 如果旧列表为空，直接使用新列表
        if (!lastItem) {
            this.chatRecords = newList
            return
        }
        // 获取在新数据列表中的下标
        let idx = getIndex(lastItem, newList)
        // 如果发起了评价之后，又追加了一条新消息
        // 评价的评论将不在新返回的评论列表中
        // 这边需要判断如果 lastItem 的类型为评价，并且 idx === -1 的情况
        // 需要将 lastItem 指向 lastItem 的前一项：即 last second item
        if (this.isGrade(lastItem) && idx === -1) {
            needDeleteItem = lastItem
            lastItem = oldList[oldList.length - 2]
            // 如果只有一条记录，就不继续查找了
            if (!lastItem) {
                this.chatRecords = newList
                return
            }
            idx = getIndex(lastItem, newList)
        }

        if (idx !== -1) {
            // 获取裁剪后的新数组
            const diffList = newList.slice(idx + 1)
            if (!diffList.length) {
                return
            }
            // *如果是检测到有关闭的系统消息
            // 这是在正常轮询时，如果协助超时了
            // 会有一条关闭的系统信息
            // 检测最后一条信息的类型
            const lastDiffItem = diffList[diffList.length - 1]
            const isNotice = lastDiffItem.type_id === commentTypes.notice.value
            if (isNotice) {
                this.getOrderDetail()
                // 停止轮询
                this.stopLoopFetch()
            }
            if (needDeleteItem) {
                // 删除旧列表中需要删除的元素
                remove(oldList, n => n.id === needDeleteItem.id)
            }
            oldList.push(...diffList)
            if (isNotice) {
                return this.$nextTick(() => {
                    this.scrollToBottom()
                })
            }
            return diffList.length
        }
    }
    // 开始轮训
    startLoopFetch(delay = 5000) {
        if (this.isClosed) {
            return
        }
        this.fetchTimer = setInterval(() => {
            this.pullComment((originComments: any[]) => {
                if (this.loopCancel) {
                    // 放弃此次的数据
                    return
                }
                // 转换后的评论
                const comments = originComments.reverse().map(generateComment)
                // 合并操作，向后合并
                const latestLen =  this.mergeChatRecordBackward(this.chatRecords, comments)
                if (latestLen) {
                    // 获取最新一项消息的 dom 节点
                    // 总共滚动高度: realScrollHeight = el.scrollHeight - el.clientHeight
                    // 当前滚动距离: el.scrollTop
                    // 如果 realScrollHeight - el.scrollTop > (dom.clientHeight / 2)
                    const { chatListEl } = this
                    this.$nextTick(() => {
                        const latestElSelector = '#help-report-detail .history-item:last-child'
                        const latestEl = document.querySelector(latestElSelector) as HTMLElement
                        const latestElHeight = latestEl.clientHeight
                        const realScrollHeight = chatListEl.scrollHeight - chatListEl.clientHeight
                        if (realScrollHeight - chatListEl.scrollTop > (latestElHeight / 2)) {
                            this.latestLen = latestLen
                            this.latestVisible = true
                        }
                    })
                }
            })
        }, delay)
    }
    stopLoopFetch() {
        clearInterval(this.fetchTimer)
    }
}
